import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "dataSelection",
  class: "flex-container-row gap10",
  style: {"align-items":"center","margin-bottom":"10px"}
}
const _hoisted_2 = {
  class: "flex-container-row filter-section",
  style: {"min-width":"520px"}
}
const _hoisted_3 = { style: {"font-weight":"bold","margin-right":"20px"} }
const _hoisted_4 = { class: "flex-container-row filter-section gap20" }
const _hoisted_5 = { style: {"font-weight":"bold"} }
const _hoisted_6 = {
  class: "flex-container-row",
  style: {"gap":"20px","flex-wrap":"wrap","align-items":"center"}
}
const _hoisted_7 = { class: "flex-container-row filter-section gap20" }
const _hoisted_8 = { style: {"font-weight":"bold"} }
const _hoisted_9 = {
  class: "flex-container-row",
  style: {"gap":"20px","flex-wrap":"wrap"}
}
const _hoisted_10 = {
  key: 0,
  class: "redText"
}
const _hoisted_11 = {
  key: 1,
  class: "flex-node-col"
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_radio_group = _resolveComponent("radio-group")!
  const _component_k_input = _resolveComponent("k-input")!
  const _component_k_label = _resolveComponent("k-label")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_k_button = _resolveComponent("k-button")!
  const _component_search_input = _resolveComponent("search-input")!
  const _component_material_tree_list = _resolveComponent("material-tree-list")!
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.localize('DataSelection')) + ":", 1),
        _createVNode(_component_radio_group, {
          "data-items": _ctx.choices,
          layout: "horizontal",
          modelValue: _ctx.dataSource.filterMode,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dataSource.filterMode) = $event))
        }, null, 8, ["data-items", "modelValue"]),
        _withDirectives(_createElementVNode("div", null, [
          _createTextVNode(" : "),
          _createVNode(_component_k_input, {
            id: "txtEqSn",
            ref: "eqRef",
            modelValue: _ctx.dataSource.equipmentSn,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataSource.equipmentSn) = $event)),
            rounded: "full",
            class: "txtEqSn",
            onKeydown: _ctx.checkFilterSubmit
          }, null, 8, ["modelValue", "onKeydown"])
        ], 512), [
          [_vShow, _ctx.dataSource.filterMode === 'equipment']
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.localize('BomFilter')) + ":", 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_checkbox, {
            id: "chkFilterHasProductionBom",
            modelValue: _ctx.dataSource.filter.withProductionBom,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataSource.filter.withProductionBom) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_k_label, { for: "chkFilterHasProductionBom" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.localizeBomItemText('BOMitems_Production')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_checkbox, {
            id: "chkFilterHasMaintenanceBom",
            modelValue: _ctx.dataSource.filter.withMaintenanceBom,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataSource.filter.withMaintenanceBom) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_k_label, { for: "chkFilterHasMaintenanceBom" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.localizeBomItemText('BOMitems_Maintenance')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_checkbox, {
            id: "chkFilterHasRecommendedItemsBom",
            modelValue: _ctx.dataSource.filter.withRecommendedItemsBom,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataSource.filter.withRecommendedItemsBom) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_k_label, { for: "chkFilterHasRecommendedItemsBom" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.localizeBomItemText('BOMitems_Recommended')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_checkbox, {
            id: "chkFilterHasAlternativeItemsBom",
            modelValue: _ctx.dataSource.filter.withAlternativeItemsBom,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataSource.filter.withAlternativeItemsBom) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_k_label, { for: "chkFilterHasAlternativeItemsBom" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.localizeBomItemText('BOMitems_Alternatives')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_checkbox, {
            id: "chkFilterHasReplacement",
            modelValue: _ctx.dataSource.filter.withReplacement,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dataSource.filter.withReplacement) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_k_label, { for: "chkFilterHasReplacement" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.localize('HasReplacement')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.localize('MaterialFilter')) + ":", 1),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_checkbox, {
            id: "chkFilterHasPicture",
            modelValue: _ctx.dataSource.filter.withPicture,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dataSource.filter.withPicture) = $event)),
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setFilter($event.srcElement.id)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_k_label, { for: "chkFilterHasPicture" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.localize('HasPicture')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_checkbox, {
            id: "chkFilterHasNoPicture",
            modelValue: _ctx.dataSource.filter.withNoPicture,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dataSource.filter.withNoPicture) = $event)),
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setFilter($event.srcElement.id)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_k_label, { for: "chkFilterHasNoPicture" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.localize('HasNoPicture')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_checkbox, {
            id: "chkFilterHasPdfFiles",
            modelValue: _ctx.dataSource.filter.withPdfFile,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dataSource.filter.withPdfFile) = $event)),
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setFilter($event.srcElement.id)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_k_label, { for: "chkFilterHasPdfFiles" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.localize('HasPdfFile')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_checkbox, {
            id: "chkFilterHasNoPdfFiles",
            modelValue: _ctx.dataSource.filter.withNoPdfFile,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.dataSource.filter.withNoPdfFile) = $event)),
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setFilter($event.srcElement.id)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_k_label, { for: "chkFilterHasNoPdfFiles" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.localize('HasNoPdfFile')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _createVNode(_component_k_button, {
        onClick: _ctx.onApplyFilter,
        disabled: !_ctx.filterAllowed,
        style: {"min-width":"70px"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.localize('apply')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    _createVNode(_component_search_input, {
      ref: "searchInputRef",
      "search-text": _ctx.searchText,
      onNewSearchInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.activeSearchInput = $event))
    }, null, 8, ["search-text"]),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.errorMessage), 1))
      : (_ctx.anyFilteredData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_material_tree_list, {
              "material-data": _ctx.filteredSpareParts,
              "search-input": _ctx.activeSearchInput,
              "admin-mode": true,
              "equipment-mode": _ctx.isEquipmentMode
            }, null, 8, ["material-data", "search-input", "equipment-mode"])
          ]))
        : (_ctx.hasLoaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.localize('notFound')), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_loader, { class: "mt-20" })
            ]))
  ], 64))
}